"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackFab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const icons_material_1 = require("@mui/icons-material");
const material_1 = require("@mui/material");
const react_1 = require("react");
const feedback_container_1 = require("./feedback-container");
const log_context_1 = require("../../../context/log-context");
const log_1 = require("../../../model/log");
exports.FeedbackFab = (0, react_1.memo)(({ currentPlayTime, passageDetails, onOpen }) => {
    const theme = (0, material_1.useTheme)();
    const { logEvent } = (0, log_context_1.useLog)();
    const [open, setOpen] = (0, react_1.useState)(false);
    const openFeedback = (0, react_1.useCallback)(() => {
        logEvent(log_1.LogEventType.Click, log_1.LogEventClickName.PassageFeedbackOpen, {
            passageId: passageDetails.meta.id,
        });
        setOpen(true);
        if (onOpen) {
            onOpen();
        }
    }, [logEvent, onOpen, passageDetails.meta.id]);
    const closeFeedback = (0, react_1.useCallback)(() => {
        logEvent(log_1.LogEventType.Click, log_1.LogEventClickName.PassageFeedbackClose, {
            passageId: passageDetails.meta.id,
        });
        setOpen(false);
    }, [logEvent, passageDetails.meta.id]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Fab, { onClick: openFeedback, color: "info", style: {
                    position: "fixed",
                    bottom: theme.spacing(14),
                    right: theme.spacing(4),
                }, children: (0, jsx_runtime_1.jsx)(icons_material_1.Feedback, { style: { color: theme.palette.primary.contrastText } }) }), (0, jsx_runtime_1.jsxs)(material_1.Dialog, { open: open, onClose: closeFeedback, fullWidth: true, maxWidth: "sm", children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, { children: "Feedback" }), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { dividers: true, children: (0, jsx_runtime_1.jsx)(feedback_container_1.FeedbackContainer, { onSubmit: closeFeedback, passageDetails: passageDetails, currentPlayTime: currentPlayTime }) })] })] }));
});
exports.FeedbackFab.displayName = "FeedbackContainer";
